import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";

import Animations from "../../utils/Animations";
import { setUserInfoAction } from "../../redux/actions/userInfoActions/userInfoActions";
import { baseOrganRoute, baseAdminRoute } from "../../utils";

const SideBarLayout = ({ isOrgan }) => {
  const [isShowSidebar, setIsShowSidebar] = useState(true);

  // Redux Dispatch
  const dispatch = useDispatch();

  // User Information
  useEffect(() => {
    dispatch(setUserInfoAction());
  }, []);

  const toggleSidebar = () => setIsShowSidebar(!isShowSidebar);

  return (
    <Fragment>
      {isShowSidebar && (
        <Animations name="fadeIn">
          <div id="vertical-menu" className="vertical-menu">
            {isOrgan ? <Organ /> : <Admin />}
          </div>
        </Animations>
      )}

      <div
        className="d-none d-lg-block"
        style={{
          position: "fixed",
          bottom: "10px",
          right: "15px",
          zIndex: 1001,
        }}
      >
        <button className="btn btn-primary" onClick={toggleSidebar}>
          <i className="fa fa-bars" />
        </button>
      </div>
    </Fragment>
  );
};

export default SideBarLayout;

const Admin = () => {
  const appConfigs = useSelector((state) => state.appConfigs);
  const userInfo = useSelector((state) => state.userInfo);
  const permission = useSelector((state) => state.permission);

  const renderMenuItems = (menuItems) =>
    menuItems
      .filter(Boolean)
      .map(({ to, label, icon, subItems, badge, badgeColor }) => (
        <li key={to}>
          {subItems ? (
            <>
              <a href="#" className="has-arrow waves-effect">
                <i className={icon} />
                <span>{label}</span>
                <span
                  className={`badge badge-${badgeColor || "primary"
                    } ml-1 px-2 py-1 rounded-pill`}
                >
                  {badge}
                </span>
              </a>
              <ul className="sub-menu">{renderMenuItems(subItems)}</ul>
            </>
          ) : (
            <NavLink
              activeClassName="mm-active"
              to={to}
              className="waves-effect"
              exact
            >
              {icon && <i className={icon} />}
              <span>{label}</span>
              <span
                className={`badge badge-${badgeColor || "primary"
                  } ml-1 px-2 py-1 rounded-pill`}
              >
                {badge}
              </span>
            </NavLink>
          )}
        </li>
      ));

  const menuItems = [
    {
      to: baseAdminRoute("/Admin/Dashboard"),
      label: "داشبورد",
      icon: "mdi mdi-airplay",
    },
    {
      to: baseAdminRoute("/Admin/Orders"),
      label: "سفارشات",
      icon: "mdi mdi-shopping-outline",
    },
    {
      label: "مالی",
      ...((appConfigs.pending_official_factors ||
        appConfigs.waiting_payment_orders) && {
        badge:
          appConfigs.pending_official_factors +
          appConfigs.waiting_payment_orders,
      }),
      icon: "mdi mdi-file-document-box-multiple-outline",
      subItems: [
        {
          to: baseAdminRoute("/Admin/Official-Invoice"),
          label: "درخواست های فاکتور رسمی",
          ...(appConfigs.pending_official_factors && {
            badge: appConfigs.pending_official_factors,
          }),
        },
        {
          to: baseAdminRoute("/Admin/Waiting-Payment-Orders"),
          label: "سفارشات منتظر پرداخت",
          ...(appConfigs.waiting_payment_orders && {
            badge: appConfigs.waiting_payment_orders,
          }),
        },
        {
          to: baseAdminRoute("/Admin/Violations-Penalty"),
          label: "تخلفات دارای جریمه",
        },
        permission.payment_transactions_list && {
          to: baseAdminRoute("/Admin/PaymentTransaction"),
          label: "سوابق پرداخت",
        },
        permission.payment_transactions_list && {
          to: baseAdminRoute("/Admin/Transaction"),
          label: "تراکنش کیف پول",
        },
        permission.payment_transactions_list && {
          to: baseAdminRoute("/Admin/Tara-Refund"),
          label: "استرداد وجه تارا",
        },
        permission.invoices_list && {
          to: baseAdminRoute("/Admin/Invoice"),
          label: "فاکتورها",
        },
        permission.wallet_group_charge && {
          to: baseAdminRoute("/Admin/GroupCharges"),
          label: "شارژ گروهی",
        },
        permission.used_discounts && {
          to: baseAdminRoute("/Admin/UseDiscounts"),
          label: "کدهای تخفیف استفاده شده",
        },
        { to: baseAdminRoute("/Admin/DiscountCoupons"), label: "کد تخفیف" },
        { to: baseAdminRoute("/Admin/CompareOrders"), label: "مقایسه سفارشات" },
        // { to: baseAdminRoute("/Admin/"), label: "جرائم تخلفات" },
        // { to: baseAdminRoute("/Admin/"), label: "درخواست های فاکتور رسمی" },
      ],
    },
    {
      label: "انسانی",
      icon: "mdi mdi-account-convert",
      subItems: [
        {
          to: baseAdminRoute("/Admin/Personnels"),
          label: "پرسنل (کاربامایارها)",
        },
        { to: baseAdminRoute("/Admin/Violations"), label: "تخلفات" },
        { to: baseAdminRoute("/Admin/FailureRequests"), label: "درخواست ها" },
        permission.recruitment_list && {
          to: baseAdminRoute("/Admin/Recruitment"),
          label: "جذب نیرو",
        },
      ],
    },
    {
      label: "امورمشتریان",
      icon: "mdi mdi-account-box-outline",
      ...((appConfigs.new_critics_suggestions ||
        appConfigs.new_user_cancels ||
        appConfigs.new_return_users) && {
        badge:
          appConfigs.new_critics_suggestions +
          appConfigs.new_user_cancels +
          appConfigs.new_return_users,
      }),
      subItems: [
        {
          to: baseAdminRoute("/Admin/UserCancelOrders"),
          label: "آخرین سفارشات لغوشده",
          ...(appConfigs.new_user_cancels && {
            badge: appConfigs.new_user_cancels,
            badgeColor: "danger",
          }),
        },
        {
          to: baseAdminRoute("/Admin/UserReturnOrders"),
          label: "آخرین مشتریان بازگشتی",
          ...(appConfigs.new_return_users && {
            badge: appConfigs.new_return_users,
            badgeColor: "danger",
          }),
        },
        {
          to: baseAdminRoute("/Admin/CriticsSuggestions"),
          label: "انتقادات و پیشنهادات",
          ...(appConfigs.new_critics_suggestions && {
            badge: appConfigs.new_critics_suggestions,
          }),
        },
        permission.run_shell_statistics && {
          to: baseAdminRoute("/Admin/Statistics"),
          label: "آمارگیری",
        },
        permission.roulette_results && {
          to: baseAdminRoute("/Admin/RouletteResults"),
          label: "برندگان گردونه",
        },
      ],
    },
    {
      label: "مدیریت",
      icon: "mdi mdi-view-list",
      subItems: [
        { to: baseAdminRoute("/Admin/Users"), label: "کاربران" },
        permission.admins_get && {
          to: baseAdminRoute("/Admin/Admins"),
          label: "مدیریت دسترسی ها",
        },
        { to: baseAdminRoute("/Admin/Logs"), label: "تاریخچه" },
        { to: baseAdminRoute("/Admin/BackUps"), label: "پشتیبان گیری" },
      ],
    },
    {
      label: "سرویس ها",
      icon: "mdi mdi-format-list-checkbox",
      subItems: [
        {
          to: baseAdminRoute("/Admin/ReturnUserStatus"),
          label: "وضعیت بازگشت مشتری",
        },
        permission.sms_messages_list && {
          to: baseAdminRoute("/Admin/SMS-Templates"),
          label: "قالب های پیامکی",
        },
        { to: baseAdminRoute("/Admin/Config"), label: "تنظیمات" },
        { to: baseAdminRoute("/Admin/Categories"), label: "دسته بندی" },
        { to: baseAdminRoute("/Admin/Services"), label: "خدمات" },
        { to: baseAdminRoute("/Admin/Items"), label: "آیتم ها" },
        { to: baseAdminRoute("/Admin/CancelingReasons"), label: "دلایل لغو" },
        { to: baseAdminRoute("/Admin/FailingReasons"), label: "دلایل کنسلی" },
        { to: baseAdminRoute("/Admin/RejectionReason"), label: "دلایل رد" },
        permission.roulette_items_list && {
          to: baseAdminRoute("/Admin/Roulette"),
          label: "گردونه",
        },
      ],
    },
    {
      label: "سازمان",
      icon: "mdi mdi-sitemap",
      subItems: [
        { to: baseAdminRoute("/Admin/Employers"), label: "سازمان ها" },
        permission.entered_employee_code_list && {
          to: baseAdminRoute("/Admin/EnteredEmployeeCodes"),
          label: "کدهای پرسنلی وارد شده",
        },
      ],
    },
    {
      label: "مناطق",
      icon: "mdi mdi-earth",
      subItems: [
        { to: baseAdminRoute("/Admin/Provinces"), label: "استان ها" },
        { to: baseAdminRoute("/Admin/Cities"), label: "شهر ها" },
      ],
    },
  ];

  return (
    <>
      <UserProfile userInfo={userInfo} />
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">
          {renderMenuItems(menuItems)}
        </ul>
      </div>
    </>
  );
};

const UserProfile = ({ userInfo }) => (
  <div className="user-wid text-center pt-4">
    <div className="user-img">
      <Link to={baseAdminRoute("/Admin/Profile/Edit")}>
        <img
          src={userInfo.avatar}
          alt={`${userInfo?.first_name} ${userInfo?.last_name}`}
          className="avatar-md mx-auto rounded-circle"
        />
      </Link>
    </div>
    <div className="mt-3">
      <span className="text-dark font-weight-medium font-size-16 line-height-h">
        {userInfo?.first_name || userInfo?.last_name
          ? `${userInfo.first_name} ${userInfo.last_name}`
          : "به کارباما خوش آمدید"}
      </span>
      <p className="text-body mt-1 mb-0 font-size-13">{userInfo.mobile}</p>
      <Link
        to={baseAdminRoute("/Auth/Logout")}
        className="text-danger waves-effect"
      >
        <span className="fas fa-sign-out-alt mr-1" />
        <span>خروج</span>
      </Link>
    </div>
  </div>
);

const Organ = () => {
  // User Information
  const userInfo = useSelector((state) => state.userInfo);

  return (
    <>
      <div className="user-wid text-center pt-4">
        <div className="user-img">
          <Link to={baseOrganRoute("/Organ/Profile/Edit")}>
            <img
              src={userInfo.avatar}
              alt={`${userInfo?.first_name} ${userInfo?.last_name}`}
              className="avatar-md mx-auto rounded-circle"
            />
          </Link>
        </div>
        <div className="mt-3">
          <span className="text-dark font-weight-medium font-size-16 line-height-h">
            {userInfo?.first_name || userInfo?.last_name
              ? `${userInfo.first_name} ${userInfo.last_name}`
              : "به کارباما خوش آمدید"}
          </span>
          <p className="text-body mt-1 mb-0 font-size-13">{userInfo.mobile}</p>
          <Link
            to={baseOrganRoute("/Auth/Logout")}
            className="text-danger waves-effect"
          >
            <span className="fas fa-sign-out-alt mr-1" />
            <span>خروج</span>
          </Link>
        </div>
      </div>
      {/*- Sidemenu */}
      <div id="sidebar-menu">
        {/* Left Menu Start */}
        <ul className="metismenu list-unstyled" id="side-menu">
          <li className="menu-title">منو</li>
          <li>
            <NavLink
              activeClassName="mm-active"
              to={baseOrganRoute("/Organ/Dashboard")}
              className="waves-effect"
              exact
            >
              <i className="mdi mdi-airplay" />
              <span>داشبورد</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              activeClassName="mm-active"
              to={baseOrganRoute("/Organ/Orders")}
              className="waves-effect"
              exact
            >
              <i className="mdi mdi-shopping-outline" />
              <span>سفارشات</span>
            </NavLink>
          </li>
        </ul>
      </div>
      {/* Sidebar */}
    </>
  );
};
